import React, { useEffect, useState } from 'react';
import './AboutPressSnippet.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';
import { BREAKPOINTS } from '../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

/**
 * Renders the about press snippet module
 * @param {boolean} isDarkImage
 * @param {string} title
 * @param {object} image
 * @param {string} quote
 * @param {object} logo
 * @param {string} ctaText
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const AboutPressSnippet = ({ isDarkImage, title, image, quote, logo, ctaText, ctaLink }) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  return (
    <div className="c-about-press-snippet">
      <div className="c-about-press-snippet__inner">
        <div
          className="c-about-press-snippet__image-card"
          style={{ backgroundImage: `url(${image.url})` }}
        >
          <div
            className={`c-about-press-snippet__title h4-right-grotesk ${
              isDarkImage ? 'color-white' : 'color-black'
            }`}
          >
            <h4>{title}</h4>
          </div>
        </div>
        <div className="c-about-press-snippet__snippet-container">
          <div className="c-about-press-snippet__snippet module-background-color-orange">
            <div className="c-about-press-snippet__quotation h4-right-grotesk">
              <span>“</span>
            </div>
            <div className="c-about-press-snippet__quote h3-roobert">
              <h3>{quote}</h3>
            </div>
            <div className="c-about-press-snippet__logo">
              <img src={logo.url} alt={logo.alt} />
            </div>
          </div>
          {isDesktop && (
            <CTAButton
              type={'secondary'}
              link={ctaLink}
              text={ctaText}
              target={'_self'}
              additionalClasses={'color-black cta'}
            />
          )}
        </div>
      </div>
      {!isDesktop && (
        <CTAButton
          type={'secondary'}
          link={ctaLink}
          text={ctaText}
          target={'_self'}
          additionalClasses={'color-black cta'}
        />
      )}
    </div>
  );
};

export default AboutPressSnippet;
